import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

export const PortalPreset = definePreset(Aura, {
  primitive: {
    borderRadius: {
      none: "0",
      xs: "2px",
      sm: "4px",
      md: "8px",
      lg: "12px",
      xl: "16px",
    },
  },
  semantic: {
    primary: {
      50: "{orange.50}",
      100: "{orange.100}",
      200: "{orange.200}",
      300: "{orange.300}",
      400: "{orange.400}",
      500: "{orange.500}",
      600: "{orange.600}",
      700: "{orange.700}",
      800: "{orange.800}",
      900: "{orange.900}",
      950: "{orange.950}",
    },
    success: {
      50: "var(--color-success-light)",
      100: "var(--color-success-light)",
      200: "var(--color-success-light)",
      300: "var(--color-success-light)",
      400: "var(--color-success)",
      500: "var(--color-success)",
      600: "var(--color-success)",
      700: "var(--color-success)",
      800: "var(--color-success)",
      900: "var(--color-success)",
      950: "var(--color-success)",
    },
    error: {
      50: "var(--color-error-light)",
      100: "var(--color-error-light)",
      200: "var(--color-error-light)",
      300: "var(--color-error-light)",
      400: "var(--color-error)",
      500: "var(--color-error)",
      600: "var(--color-error)",
      700: "var(--color-error)",
      800: "var(--color-error)",
      900: "var(--color-error)",
      950: "var(--color-error)",
    },
    warning: {
      50: "var(--color-warning-light)",
      100: "var(--color-warning-light)",
      200: "var(--color-warning-light)",
      300: "var(--color-warning-light)",
      400: "var(--color-warning)",
      500: "var(--color-warning)",
      600: "var(--color-warning)",
      700: "var(--color-warning)",
      800: "var(--color-warning)",
      900: "var(--color-warning)",
      950: "var(--color-warning)",
    },
    info: {
      50: "var(--color-info-light)",
      100: "var(--color-info-light)",
      200: "var(--color-info-light)",
      300: "var(--color-info-light)",
      400: "var(--color-info)",
      500: "var(--color-info)",
      600: "var(--color-info)",
      700: "var(--color-info)",
      800: "var(--color-info)",
      900: "var(--color-info)",
      950: "var(--color-info)",
    },
    nieuw: {
      50: "var(--color-nieuw-light)",
      100: "var(--color-nieuw-light)",
      200: "var(--color-nieuw-light)",
      300: "var(--color-nieuw-light)",
      400: "var(--color-nieuw)",
      500: "var(--color-nieuw)",
      600: "var(--color-nieuw)",
      700: "var(--color-nieuw)",
      800: "var(--color-nieuw)",
      900: "var(--color-nieuw)",
      950: "var(--color-nieuw)",
    },
    aangepast: {
      50: "var(--color-aangepast-light)",
      100: "var(--color-aangepast-light)",
      200: "var(--color-aangepast-light)",
      300: "var(--color-aangepast-light)",
      400: "var(--color-aangepast)",
      500: "var(--color-aangepast)",
      600: "var(--color-aangepast)",
      700: "var(--color-aangepast)",
      800: "var(--color-aangepast)",
      900: "var(--color-aangepast)",
      950: "var(--color-aangepast)",
    },
    verzonden: {
      50: "var(--color-verzonden-light)",
      100: "var(--color-verzonden-light)",
      200: "var(--color-verzonden-light)",
      300: "var(--color-verzonden-light)",
      400: "var(--color-verzonden)",
      500: "var(--color-verzonden)",
      600: "var(--color-verzonden)",
      700: "var(--color-verzonden)",
      800: "var(--color-verzonden)",
      900: "var(--color-verzonden)",
      950: "var(--color-verzonden)",
    },
    bekeken: {
      50: "var(--color-bekeken-light)",
      100: "var(--color-bekeken-light)",
      200: "var(--color-bekeken-light)",
      300: "var(--color-bekeken-light)",
      400: "var(--color-bekeken)",
      500: "var(--color-bekeken)",
      600: "var(--color-bekeken)",
      700: "var(--color-bekeken)",
      800: "var(--color-bekeken)",
      900: "var(--color-bekeken)",
      950: "var(--color-bekeken)",
    },
    deels_geaccepteerd: {
      50: "var(--color-deels-geaccepteerd-light)",
      100: "var(--color-deels-geaccepteerd-light)",
      200: "var(--color-deels-geaccepteerd-light)",
      300: "var(--color-deels-geaccepteerd-light)",
      400: "var(--color-deels-geaccepteerd)",
      500: "var(--color-deels-geaccepteerd)",
      600: "var(--color-deels-geaccepteerd)",
      700: "var(--color-deels-geaccepteerd)",
      800: "var(--color-deels-geaccepteerd)",
      900: "var(--color-deels-geaccepteerd)",
      950: "var(--color-deels-geaccepteerd)",
    },
    alles_geaccepteerd: {
      50: "var(--color-alles-geaccepteerd-light)",
      100: "var(--color-alles-geaccepteerd-light)",
      200: "var(--color-alles-geaccepteerd-light)",
      300: "var(--color-alles-geaccepteerd-light)",
      400: "var(--color-alles-geaccepteerd)",
      500: "var(--color-alles-geaccepteerd)",
      600: "var(--color-alles-geaccepteerd)",
      700: "var(--color-alles-geaccepteerd)",
      800: "var(--color-alles-geaccepteerd)",
      900: "var(--color-alles-geaccepteerd)",
      950: "var(--color-alles-geaccepteerd)",
    },
    foute_inzending: {
      50: "var(--color-afgewezen-light)",
      100: "var(--color-afgewezen-light)",
      200: "var(--color-afgewezen-light)",
      300: "var(--color-afgewezen-light)",
      400: "var(--color-afgewezen)",
      500: "var(--color-afgewezen)",
      600: "var(--color-afgewezen)",
      700: "var(--color-afgewezen)",
      800: "var(--color-afgewezen)",
      900: "var(--color-afgewezen)",
      950: "var(--color-afgewezen)",
    },
    ingepland: {
      50: "var(--color-ingepland-light)",
      100: "var(--color-ingepland-light)",
      200: "var(--color-ingepland-light)",
      300: "var(--color-ingepland-light)",
      400: "var(--color-ingepland)",
      500: "var(--color-ingepland)",
      600: "var(--color-ingepland)",
      700: "var(--color-ingepland)",
      800: "var(--color-ingepland)",
      900: "var(--color-ingepland)",
      950: "var(--color-ingepland)",
    },
    ingetrokken: {
      50: "var(--color-ingetrokken-light)",
      100: "var(--color-ingetrokken-light)",
      200: "var(--color-ingetrokken-light)",
      300: "var(--color-ingetrokken-light)",
      400: "var(--color-ingetrokken)",
      500: "var(--color-ingetrokken)",
      600: "var(--color-ingetrokken)",
      700: "var(--color-ingetrokken)",
      800: "var(--color-ingetrokken)",
      900: "var(--color-ingetrokken)",
      950: "var(--color-ingetrokken)",
    },
    afgewezen: {
      50: "var(--color-afgewezen-light)",
      100: "var(--color-afgewezen-light)",
      200: "var(--color-afgewezen-light)",
      300: "var(--color-afgewezen-light)",
      400: "var(--color-afgewezen)",
      500: "var(--color-afgewezen)",
      600: "var(--color-afgewezen)",
      700: "var(--color-afgewezen)",
      800: "var(--color-afgewezen)",
      900: "var(--color-afgewezen)",
      950: "var(--color-afgewezen)",
    },
    gefactureerd: {
      50: "var(--color-gefactureerd-light)",
      100: "var(--color-gefactureerd-light)",
      200: "var(--color-gefactureerd-light)",
      300: "var(--color-gefactureerd-light)",
      400: "var(--color-gefactureerd)",
      500: "var(--color-gefactureerd)",
      600: "var(--color-gefactureerd)",
      700: "var(--color-gefactureerd)",
      800: "var(--color-gefactureerd)",
      900: "var(--color-gefactureerd)",
      950: "var(--color-gefactureerd)",
    },
    colorScheme: {
      light: {
        surface: {
          0: "#ffffff",
          50: "{zinc.50}",
          100: "{zinc.100}",
          200: "{zinc.200}",
          300: "{zinc.300}",
          400: "{zinc.400}",
          500: "{zinc.500}",
          600: "{zinc.600}",
          700: "{zinc.700}",
          800: "{zinc.800}",
          900: "{zinc.900}",
          950: "{zinc.950}",
          1000: "#000000",
        },
        background: {
          0: "{surface.0}",
          50: "{surface.50}",
          100: "{surface.100}",
          200: "{surface.200}",
          300: "{surface.300}",
          400: "{surface.400}",
          500: "{surface.500}",
          600: "{surface.600}",
          700: "{surface.700}",
          800: "{surface.800}",
          900: "{surface.900}",
          950: "{surface.950}",
        },
        text: {
          0: "{surface.950}",
          50: "{surface.900}",
          100: "{surface.800}",
          200: "{surface.700}",
          300: "{surface.600}",
          400: "{surface.500}",
          500: "{surface.400}",
          600: "{surface.300}",
          700: "{surface.200}",
          800: "{surface.100}",
          900: "{surface.50}",
          950: "{surface.0}",
        },
        root: {
          checkedBackground: "var(--p-primary-400)",
          checkedColor: "#ffffff",
          hoverBackground: "var(--p-background-100)",
          hoverColor: "var(--p-text-800)",
          activeBackground: "var(--p-background-200)",
          activeColor: "var(--p-text-800)",
          focusColor: "var(--p-primary-400)",
        },
      },
      dark: {
        surface: {
          0: "#ffffff",
          50: "{zinc.50}",
          100: "{zinc.100}",
          200: "{zinc.200}",
          300: "{zinc.300}",
          400: "{zinc.400}",
          500: "{zinc.500}",
          600: "{zinc.600}",
          700: "{zinc.700}",
          800: "{zinc.800}",
          900: "{zinc.900}",
          950: "{zinc.950}",
        },
        background: {
          0: "{surface.950}",
          50: "{surface.900}",
          100: "{surface.800}",
          200: "{surface.700}",
          300: "{surface.600}",
          400: "{surface.500}",
          500: "{surface.400}",
          600: "{surface.300}",
          700: "{surface.200}",
          800: "{surface.100}",
          900: "{surface.50}",
          950: "{surface.0}",
        },
        text: {
          0: "{surface.50}",
          50: "{surface.100}",
          100: "{surface.200}",
          200: "{surface.300}",
          300: "{surface.400}",
          400: "{surface.500}",
          500: "{surface.600}",
          600: "{surface.700}",
          700: "{surface.800}",
          800: "{surface.900}",
          900: "{surface.950}",
          950: "{surface.0}",
        },
        root: {
          checkedBackground: "var(--p-primary-400)",
          checkedColor: "#ffffff",
          hoverBackground: "var(--p-background-200)",
          hoverColor: "var(--p-text-100)",
          activeBackground: "var(--p-background-300)",
          activeColor: "var(--p-text-0)",
          focusColor: "var(--p-primary-400)",
        },
      },
    },
  },
});
